import { useFormikContext } from 'formik';

import Dropdown from 'components/common/form/dropdown/dropdown';
import { tokenOptions } from 'lib/constants';
import { TokenType, FormValues } from 'types';

import { useFungibleTokensIncludingNEAR } from 'lib/hooks/use-fungible-tokens-including-near';
import { useAppDispatch } from 'redux/use-hooks';
import { actions as tokensSliceActions } from 'redux/slices/tokens';
const { setActiveToken } = tokensSliceActions;

import { StyledInputLabel, StyledInputWrapper } from '../send-view.style';

const DropdownTokensField = ({ inputElement }) => {
  const formik = useFormikContext<FormValues>();
  const { values, setFieldValue } = formik;
  const dispatch = useAppDispatch();
  const fungibleTokensList = useFungibleTokensIncludingNEAR();
  return (
    <StyledInputWrapper mb={values.token === 'OCC' ? '16px' : '20px'}>
      <StyledInputLabel>Select Asset</StyledInputLabel>
      <Dropdown
        variant="small"
        name="token"
        options={tokenOptions}
        value={values.token}
        onChange={(e) => {
          dispatch(
            setActiveToken(
              fungibleTokensList.find(
                (item: TokenType) =>
                  item.onChainFTMetadata.symbol === e.target.value
              )
            )
          );
          setFieldValue('amount', '');
          setFieldValue('token', e.target.value);
          inputElement.current.focus();
        }}
      />
    </StyledInputWrapper>
  );
};

export default DropdownTokensField;
